import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import InputNumber from "./components/InputNumber";
import InputNumberSettings from "./components/InputNumberSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/input_number_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'inputNumber', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.INPUT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_INPUTNUMBER'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      formItemSettings: {
        min: 0,
        precision: 2
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_INPUTNUMBER'],
      },
      settings: {
        width: {
          value: '100%',
        },
      },
    },
    pluginComponent: InputNumber, // 插件渲染组件
    pluginSettingComponent: InputNumberSettings, // 插件设置项组件
  }
}
